import {
  ChevronLeftIcon,
  FlexBox,
  JoonUIColor,
  SPACING,
  Typography,
} from "@joonapp/web-shared"
import { useEffect } from "react"
import { useNavigate } from "react-router-dom"

import { ToolId, trackPageViewed } from "./sharedTools"
import PageContentWrapper from "../../components/layout/PageContentWrapper"
import PageWrapper from "../../components/pageWrapper/PageWrapper"

type Props = {
  toolId: ToolId
  title: string
  description: string
  children: React.ReactNode
}

const ToolPage = ({ toolId, title, description, children }: Props) => {
  const navigate = useNavigate()

  useEffect(() => {
    trackPageViewed(toolId)
  }, [toolId])

  return (
    <PageWrapper style={{ background: JoonUIColor.background.xlightGray }}>
      <PageContentWrapper>
        <button
          style={{ padding: 0, alignSelf: "flex-start" }}
          onClick={() => navigate("/tools")}
        >
          <FlexBox gap={SPACING.space1} wrap={false} align="center">
            <ChevronLeftIcon size={16} color={JoonUIColor.text.secondary} />
            <Typography variant="caption" color={JoonUIColor.text.secondary}>
              All tools
            </Typography>
          </FlexBox>
        </button>
        <FlexBox direction="column" gap={SPACING.space2}>
          <Typography variant="h3" textAlign="left">
            {title}
          </Typography>
          <Typography
            variant="bodySmall"
            textAlign="left"
            color={JoonUIColor.text.secondary}
          >
            {description}
          </Typography>
        </FlexBox>
        <FlexBox
          direction="column"
          gap={SPACING.space4}
          style={{
            background: JoonUIColor.background.primaryNeutral,
            border: `1px solid ${JoonUIColor.border.default}`,
            borderRadius: SPACING.space2,
            padding: SPACING.space6,
          }}
        >
          {children}
        </FlexBox>
      </PageContentWrapper>
    </PageWrapper>
  )
}

export default ToolPage
